import {t} from '@eitje/bridge'
import {useForm} from '@eitje/form'
import utils from '@eitje/utils'
import {useSyncExternalStore} from 'react'
import {useHotkeys} from 'react-hotkeys-hook'
import {DeleteButton, SubmitButton} from '~/components/eitje_button'
import {Popout} from '~/components/popout'

const BaseLegacyFormSubmitButton = props => {
	'use no memo'
	const {
		submitConfirmation,
		onClick,
		children: buttonChildren,
		submit,
		getData: _,
		form,
		className,
		Button = SubmitButton,
		isDisabled,
		formData,
		disabled,
		t: translation,
		text,
		...otherSubmitButtonProps
	} = props
	const requiredString = t('form.required')
	const {errs = {}} = form?.validateInner?.() || {}
	const missingRequiredFields = Object.values(errs).some(e => e === requiredString)

	useHotkeys('meta+enter', submit)
	const children = translation ? null : buttonChildren || text || t('common.submit')
	const _disabled = isDisabled ? isDisabled(formData) : disabled
	const classNames = utils.makeCns(className, 'form-submit-button')
	const showSubmitConfirmation = submitConfirmation && !missingRequiredFields
	const submitButtonOnClick = showSubmitConfirmation ? undefined : onClick || submit
	const missingRequiredFieldsTooltip = missingRequiredFields && 'form.general.tooltips.missing_required_fields'
	const submitButtonPopoutTitle = missingRequiredFieldsTooltip || otherSubmitButtonProps.popoutTitle

	const submitButton = (
		<Button
			baseColor={missingRequiredFields ? 'grey' : 'blue'}
			onClick={submitButtonOnClick}
			onConfirm={submit}
			t={translation}
			data-intercom-target="form-submit-button"
			className={classNames}
			{...otherSubmitButtonProps}
			disabled={_disabled}
			formData={formData}
			missingRequiredFields={missingRequiredFields}
			popoutTitle={submitButtonPopoutTitle}
		>
			{children}
		</Button>
	)

	if (!showSubmitConfirmation) return submitButton

	return (
		<Popout
			type="confirm"
			trigger={submitButton}
			onConfirm={submit}
			body={submitConfirmation.text}
			title={submitConfirmation.title}
			confirmButtonProps={submitConfirmation.confirmButtonProps}
			disabled={_disabled}
		/>
	)
}

// Used with <ContextForm/> (form-2)
export const ContextFormSubmitButton = props => {
	'use no memo'
	const contextForm = useForm()
	const formSource = props.getData ? props : contextForm
	const {getData} = formSource
	if (!getData) return null

	return <BaseLegacyFormSubmitButton {...props} submit={formSource.submit} getData={getData} form={formSource.form} formData={getData()} />
}

// Used with <LegacyFormModal/>
// Legacy FormModal footers render outside the NewForm tree, so they subscribe to the form instance directly.
export const LegacyFormModalSubmitButton = props => {
	'use no memo'
	const {form} = props
	const snapshot = useSyncExternalStore(form.subscribe, form.getSnapshot, form.getSnapshot)

	return <BaseLegacyFormSubmitButton {...props} formData={snapshot.fields} />
}

export const FormDeleteButton = props => {
	const {submit} = useForm()
	const children = props.children || t('common.delete')
	return (
		<DeleteButton onDel={submit} {...props}>
			{children}
		</DeleteButton>
	)
}
